import * as React from "react";
import AsyncSelect from "react-select/lib/Async";
import { ValueType } from "react-select/lib/types";

import { CustomerEndpoints } from "../../endpoints/CustomerEndpoints";
import { CustomerTypeWithBoth, Contact, Business, SimpleCustomer, ExtractFriendlyName } from "../../model/Customer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faPhone, faMapPin, faPlus, faMapMarkerAlt, faBriefcase } from "@fortawesome/free-solid-svg-icons";

const CREATE_NEW = -1;
export interface OptionType {
    value: string;
    label: string;
}

export interface Props {
    customerEndpoints: CustomerEndpoints;
    isDisabledLink?: boolean;
    isInvalid?: boolean;
    className?: string;
    include: CustomerTypeWithBoth;
    value: Array<SimpleCustomer>;
    excludeCustomers?: Array<number>;
    involvementSaleFilters?: Array<number>;
    involvementRoleFilters?: Array<string>;
    onChange: (customersToOptions: Array<SimpleCustomer>) => void;

    showCreate?: boolean;
    onCreate?: () => void;
}

export default class CustomerMultiselect extends React.Component<Props, {}> {
    private latestCustomerList: Array<SimpleCustomer> = [];

    constructor(props: Props) {
        super(props);
    }

    createOption = () => {
        return {
            label: (
                <button className="btn btn-primary btn-sm">
                    <FontAwesomeIcon icon={faPlus} /> Create new...
                </button>
            ),
            value: CREATE_NEW
        };
    };

    loadOptions = async (fullTextSearch: string) => {
        const customerList = await this.props.customerEndpoints.getCustomerList(50, 0, undefined, {
            fullTextSearch,
            type: this.props.include,
            involvementRoleIds: (this.props.involvementRoleFilters || []).join(","),
            involvementSaleIds: (this.props.involvementSaleFilters || []).join(",")
        });

        this.latestCustomerList = customerList.results;
        const options = customerList.results
            .filter(customer => customer.dateArchived === null)
            .filter(customer => {
                if (!this.props.excludeCustomers) {
                    return true;
                }
                return this.props.excludeCustomers.indexOf(customer.id) < 0;
            })
            .map(customer => this.customerToOption(customer));

        if (this.props.showCreate) {
            options.unshift(this.createOption());
        }
        return options;
    };
    render() {
        return (
            <div className={this.props.className || ""}>
                <AsyncSelect
                    isDisabled={this.props.isDisabledLink}
                    loadOptions={this.loadOptions}
                    cacheOptions={false}
                    isClearable={true}
                    className={"customerSelectWidget " + (this.props.isInvalid ? "is-invalid" : "")}
                    value={this.props.value.map(c => {
                        return { label: ExtractFriendlyName(c), value: `${c.id}` };
                    })}
                    placeholder="Start typing..."
                    onChange={(ref: any, action: any) => {
                        console.dir(action);

                        if (action.action === "select-option") {
                            const customer = this.latestCustomerList.find(c => c.id === action.option.value);
                            if (!customer) {
                                return;
                            }
                            this.props.onChange([...this.props.value, customer]);
                        } else if (action.action === "remove-value") {
                            this.props.onChange(this.props.value.filter(c => `${c.id}` !== `${action.removedValue.value}`));
                        } else if (action.action === "clear") {
                            this.props.onChange([]);
                        }
                    }}
                    isMulti={true}
                />
            </div>
        );
    }

    private customerToOption(customer: SimpleCustomer | null): ValueType<{ label: React.ReactNode; value: number }> {
        if (!customer) {
            return null;
        }
        let label = (
            <div>
                <span>
                    <FontAwesomeIcon icon={faUser} className="mr-1" />
                    &nbsp;{ExtractFriendlyName(customer)}
                </span>
            </div>
        );
        return { label, value: customer.id };
    }
}



// WEBPACK FOOTER //
// ./src/components/common/CustomerMultiselect.tsx